/*
 * @Description  :	项目结构、类型接口
 * @Author       : 钱磊
 * @Date         : 2023-04-06 14:25:43
 * @LastEditors  : “qian_lei”
 * @LastEditTime : 2023-04-11 16:26:46
 * @FilePath     : \dx_execute_admin\src\api\business-setting\structureType.js
 */
import request from '../request.js'


//项目结构-模板分页列表  -----叶凡
export const getProPages = function (data) {
    return request({
        url: 'temProject/getProPages',
        method: 'post',
        data
    })
}


//项目结构-自动生成项目编号  -----叶凡
export const createNo = function (data) {
    return request({
        url: 'temProject/createNo',
        method: 'post',
        data
    })
}

//项目结构-新增/编辑模板  -----叶凡
export const saveTemPro = function (data) {
    return request({
        url: 'temProject/saveTemPro',
        method: 'post',
        data
    })
}

//项目结构-启用、禁用/删除模板  -----叶凡
export const updateTemPro = function (data) {
    return request({
        url: 'temProject/updateTemPro',
        method: 'post',
        data
    })
}

//项目结构-复制模板  -----叶凡
export const copyTemPro = function (data) {
    return request({
        url: 'temProjectTree/copyTemPro',
        method: 'post',
        data
    })
}

//项目结构-获取模板tree  -----叶凡
export const getProTree = function (data) {
    return request({
        url: 'temProjectTree/getProTree',
        method: 'post',
        data
    })
}

//项目结构-保存模板tree  -----叶凡
export const saveProTree = function (data) {
    return request({
        url: 'temProjectTree/saveProTree',
        method: 'post',
        data
    })
}

//项目结构-删除树结构节点  -----叶凡
export const deleteNode = function (data) {
    return request({
        url: 'temProjectTree/deleteNode',
        method: 'post',
        data
    })
}
